import * as React from 'react'
import { extractDbNamesFromTree } from 'containers/MenusAdmin/services/menu.service'
import { ITree } from 'containers/MenusAdmin/services/menu.types'

export const useUnassignedDbs = (databases: IDatabase[], treeData: ITree): IDatabase[] =>
  React.useMemo(() => {
    const usedDbNames = extractDbNamesFromTree(treeData)
    return databases.filter(db => !usedDbNames.includes(db.name))
  }, [databases, treeData])
